const loadingStates = {
  INIT: "initializing",
  IDLE: "idle",
  PENDING: "pending",
}

export default loadingStates
